<template>
  <!-- resp login Modal -->
    <div
      class="login-modal modal fade"
      id="loginModal"
      tabindex="-1"
      aria-labelledby="loginModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        :style="{ transform: !mediaQueries.mobileSize ? 'none' : 'inherit' }"
      >
        <div
          :style="{ height: !mediaQueries.mobileSize ? modalHeight : '0' }"
          id="modal-content"
          class="modal-content"
        >
          <div class="modal-header py-4 mx-3">
            <button
              v-if="textModalHeader == 'ورود به وبسایت'"
              id="btnCloseLoginModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal()"
            >
              <span aria-hidden="true" style="font-size: 30px">&times;</span>
            </button>
            <button
              v-if="textModalHeader == 'فراموشی رمز عبور'"
              id="btnCloseLoginModal"
              type="button"
              @click="backToLogin()"
              class="backBtn"
            >
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>

            <h5
              class="modal-title fontsize16 font-weight-bold text-color-444"
              id="loginModalLabel"
            >
              {{ textModalHeader }}
            </h5>
          </div>
          <LoginRegister v-model="modalHeight" :textModalHeader="textModalHeader" @changeTextModal="changeText" ref="LoginRegister" :showFullForm="false" />
                  </div>
      </div>
    </div>
</template>

<script>
import LoginRegister from "@/parts/Front/components/loginRegister/LoginRegister.vue"
export default {
components:{LoginRegister},
  inject:['mediaQueries'],
  name: "RespLoginModal",
  data() {
    return {
      textModalHeader: "ورود به وبسایت",
      modalHeight:"0",
      changeText:"ورود به وبسایت",
    };
  },
  methods: {
    closeModal() {
      this.$refs.LoginRegister.closeModal();
      // برگرداندن به وضعیت اولیه با بستن مودال
    },

  },
  watch:{
    changeText(val){
      this.textModalHeader=val;
    }
  }

};
</script>

<style scoped>




.login-modal .modal-content {
  height: max-content !important;
}

#modal-content {
  transition: all 0.3s;
  height: 300px;
}

.modal-content {
  min-height: 340px;
}
/* نمایش تمام صفحه مودال در حالت موبایلی
 */
@media (max-width: 768px) {
  #modal-content {
    height: 100vh !important;
    border-radius: 0 !important;
    width: 100% !important;
    position: fixed;
    top: 0;
  }
  .modal-dialog {
    margin: 0;
  }
}

#modal-content {
  transition: all 1s;
}


#btnCloseLoginModal{
  background-color:transparent
}
</style>
